module.exports = __webpack_public_path__ + "static/media/manhattan-dark-red-cord.cd56b23e.jpg";